import { TableColumnsType } from "antd";
import moment from "moment";

import { UsersTableType } from "../../models";
import { Key } from "react";

export const userColumns = (searchUser: string, searchRole: string) => {
  const columns: TableColumnsType<UsersTableType> = [
    {
      title: "Ime i prezime",
      dataIndex: "fullname",
      filteredValue: [searchUser],
      onFilter: (value: boolean | Key, record: UsersTableType) => {
        return record.fullname.toLowerCase().includes(searchUser.toLowerCase());
      },
      render: (text) => <a className="text-primary">{text}</a>,
    },
    {
      title: "Organizacija",
      dataIndex: "organization",
      responsive: ["sm"],
    },
    {
      title: "email",
      dataIndex: "email",
      responsive: ["md"],
    },
    {
      title: "Rola",
      dataIndex: "role",
      width: 180,
      filteredValue: [searchRole],
      sorter: (a, b) => a.role.localeCompare(b.role),
      onFilter: (value: boolean | Key, record: UsersTableType) => {
        return record?.role?.toLowerCase().includes(searchRole.toLowerCase());
      },
    },
    {
      title: "Datum",
      dataIndex: "date",
      width: 190,
      responsive: ["lg"],
      sorter: (a, b) => moment(a.date).diff(moment(b.date)),
    },
  ];

  return columns;
};
